export const SET_ADMINISTRATORS = 'SET_ADMINISTRATORS';
export const SET_PAGINATION = 'SET_PAGINATION';
export const DELETE_ADMINISTRATOR = 'DELETE_ADMINISTRATOR';
export const UPDATE_USER = 'UPDATE_USER';
export const SET_LIMIT = 'SET_LIMIT';
